const u = typeof window.requestIdleCallback == "function" ? window.requestIdleCallback : setTimeout,
  l = typeof window.cancelIdleCallback == "function" ? window.cancelIdleCallback : clearTimeout;
function s(e, t) {
  let n;
  function i(...o) {
    (clearTimeout(n), (n = setTimeout(() => e.apply(this, o), t)));
  }
  return (
    (i.cancel = () => {
      clearTimeout(n);
    }),
    i
  );
}
function m(e, t, n = { subtree: !0 }) {
  const o = (Array.isArray(e) ? e.flatMap((a) => a.getAnimations(n)) : e.getAnimations(n)).reduce(
    (a, r) => (r.timeline instanceof DocumentTimeline && a.push(r.finished), a),
    []
  );
  return Promise.allSettled(o).then(t);
}
const c = matchMedia("(prefers-reduced-motion: reduce)");
function d() {
  return c.matches;
}
function f(e) {
  const t = document.createElement("div");
  return ((t.textContent = e), t.innerHTML);
}
function p(e, t) {
  let n = 0;
  return function (...i) {
    const o = Date.now();
    if (o - n >= t) return ((n = o), e.apply(this, i));
  };
}
function b(e, { locale: t = "de-DE", currency: n = "EUR" } = {}) {
  if (typeof e != "number" || isNaN(e)) return "";
  const i = e / 100;
  return new Intl.NumberFormat(t, {
    style: "currency",
    currency: n,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(i);
}
function w(e, t) {
  customElements.get(e) || customElements.define(e, t);
}
export { s as a, l as c, w as d, f as e, b as f, m as o, d as p, u as r, p as t };
